const isAnchorHrefEmpty = require("./isAnchorHrefEmpty");

/**
 * @returns {void}
 */
module.exports = function disableDefaultBehaviorForEmptyLinks() {
    window.document.querySelectorAll('a').forEach(a => {
        if (a instanceof HTMLAnchorElement && isAnchorHrefEmpty(a)) {
            a.setAttribute("onclick", "return false;");
        }
    });
};